import axios from "axios";

const TaskService = () => {
  const defaultOptions = {
    baseURL: process.env.REACT_APP_CHAT_AI_ENDPOINT + "/api/v1/tasks",
    headers: {
      "Content-Type": "application/json",
      "X-XSS-Protection": "X-XSS-Protection: 1; mode=block",
      "X-Frame-Options": "SAMEORIGIN",
      "Strict-Transport-Security": "max-age=10000000",
      "Content-Security-Policy": "default-src 'self'; child-src 'none';",
      "Referrer-Policy": "no-referrer",
      "X-Content-Type-Options": "nosniff",
      Authorization: "Bearer " + localStorage.getItem("localAuthorization"),
    },
  };

  let instance = axios.create(defaultOptions);

  return instance;
};

export default TaskService();

const fetchTaskStatus = async (task_id) => {
  const res = await TaskService().get(`/${task_id}/result`);

  if (res.status === 200) {
    return res.data;
  }
};

export { fetchTaskStatus };
